import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ExportMenu from "../../Common/ExportMenu/ExportMenu";
import ExcelJS from "exceljs";
import { formatDateTimeWithoutSec } from "../../Common/helper/helpar";
import useHygieneStore from "./store/hygieneStore";

export const ExportHygieneData = () => {
  const { hygieneObservations } = useHygieneStore();

  // Export as Excel
  const downloadExcel = async () => {
    const { FromDateTime, ToDateTime } = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime ? `(${formatDateTimeWithoutSec(FromDateTime)} to ${formatDateTimeWithoutSec(ToDateTime)})` : "";
    const reportTitle = `Hygiene Observation ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 3);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 3);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow(["S.No", "Observation Name", "Status"]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    hygieneObservations.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.observationName,
        item.isActive ? "Active" : "InActive",
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [{ width: 10 }, { width: 20 }, { width: 25 }];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "HygieneObservation.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  // Export as PDF
  const downloadPDF = () => {
    const doc = new jsPDF();

    // Centered Title
    doc.text("Hygiene Observation", doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });

    // Generate table with centered text & headers
    autoTable(doc, {
      head: [["S.No", "Observation Name", "Status"]],
      body: hygieneObservations.map((row, index) => [
        { content: index + 1, styles: { halign: "center" } },
        { content: row.observationName || "N/A", styles: { halign: "center" } },
        { content: row.isActive ? "Active" : "InActive", styles: { halign: "center" } }
      ]),
      margin: { top: 20 },
      styles: { halign: "center" }, // Centers all table text
      headStyles: { halign: "center", fontStyle: "bold",  } // Centers header with bold red background
    });

    // Save the PDF
    doc.save("HygieneObservation.pdf");
  };




  return (
    <ExportMenu
      items={[
        { label: "Excel", icon: "fa-solid fa-file-excel", onClick: downloadExcel },
        { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: downloadPDF },
      ]}
    />
  );
};
